export const StringsToOptions = (strings: string[]) => strings.map((str) => ({ id: str, name: str }));